module.exports = __webpack_public_path__ + "img/minus_btn.d578512c.png";